import React, { FC, useEffect, useState } from "react";
import { Button, Modal, Row, Col } from "antd";
import _ from "lodash";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "./CheckoutForm";
import { ReactSVG } from "react-svg";
const stripePromise = loadStripe("pk_test_Et647M9Zop5eCXjCXiuFawOV");

const PaymentModal: FC<{ socket: ISocket; params?: any }> = ({
  socket,
  params,
}) => {
  return (
    <Row className="main-layout">
      <Col span={24}>
        <div className="main-column ride-dispatch-panel mr-3">
          <div className="main-content">
            <div className="main-header">
              <div className="d-flex">
                <h3 className="ml-3">beamLive Payment</h3>
              </div>
            </div>
            <Row className="mt-3">
              <Col span={24} className="beam-modal analytics-summary-modal main-content">
                <div className="tiles padding-12 w-100">
                  <Row className="d-flex">
                    <Col>
                      <span className="col-label">Payment breakdown</span>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <ul className="incident-information mt-2">
                        <li>
                          <Row>
                            <Col span={12}>
                              <p>Amount ($)</p>
                            </Col>
                            <Col span={12}>
                              <p>12</p>
                            </Col>
                          </Row>
                        </li>
                        <li>
                          <Row>
                            <Col span={12}>
                              <p>Tax ($)</p>
                            </Col>
                            <Col span={12}>
                              <p>0</p>
                            </Col>
                          </Row>
                        </li>
                        <li>
                          <Row>
                            <Col span={12}>
                              <p>Service fee ($)</p>
                            </Col>
                            <Col span={12}>
                              <p>0</p>
                            </Col>
                          </Row>
                        </li>
                        <li>
                          <Row>
                            <Col span={12}>
                              <p>Total ($)</p>
                            </Col>
                            <Col span={12}>
                              <p>12</p>
                            </Col>
                          </Row>
                        </li>
                      </ul>
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col span={24}>
                <Elements stripe={stripePromise}>
                  <CheckoutForm />
                </Elements>
              </Col>
            </Row>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default PaymentModal;
